import { createSlice } from '@reduxjs/toolkit'
import { RootState } from '../store'
import { ApiStatus } from '../../types/api/status'
import { DocumentOfSale, documentOfSalesType } from '../../types/slices/documentOfSalesType'

const initialState: documentOfSalesType =
{
    status: ApiStatus.FETCHED,
    documentOfSales: [],
    documentOfSaleSelected: {} as DocumentOfSale,
    errorMessage: undefined,
    action: ''
}

const documentOfSalesSlice = createSlice({
    name: 'documentOfSalesSlice',
    initialState,
    reducers: {
        onFetchDocumentOfSales (state, { payload }: { payload: DocumentOfSale[]}) {
        state.status = ApiStatus.FETCHED
        state.documentOfSales = payload
        state.errorMessage = undefined
        },
        onSetSelectedDocumentSale (state, { payload }: { payload: DocumentOfSale }) {
        state.documentOfSaleSelected = payload
        },
        changeStatus (state, { payload }: { payload: ApiStatus}){
        state.status = payload
        },
        setAction (state, { payload }: { payload: string }) {
        state.action = payload
        },
    }
})

export const selectDocumentOfSalesState = (state: RootState) => state.documentOfSalesSlice
export default documentOfSalesSlice.reducer
export const {
    onFetchDocumentOfSales,
    onSetSelectedDocumentSale,
    changeStatus,
    setAction,
} = documentOfSalesSlice.actions
